import { createApp } from 'vue';

import App from '@/App.vue';

import '@/styles/base.css';

createApp(App).mount('#widget');
